(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-hero-buen-fin"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag='cf-buen-fin-hero-v2';
  if(customElements.get(tag))return;
  class CharmifyBuenFinV2 extends HTMLElement{
    connectedCallback(){
      if(this._connected)return;
      this._connected=true;this._abort=new AbortController();this._visible=false;this._imagesReady=false;this._running=false;
      this._reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this._onReduced=()=>{this.toggleAttribute('data-reduced',this._reduced.matches);this.updateMotion();};
      this._onReduced();this._reduced.addEventListener('change',this._onReduced);
      document.addEventListener('visibilitychange',()=>this.updateMotion(),{signal:this._abort.signal});
      const measure=()=>this.style.setProperty('--cfbh-fall',`${this.getBoundingClientRect().height+60}px`);measure();
      if('ResizeObserver'in window){this._size=new ResizeObserver(measure);this._size.observe(this);}
      if('IntersectionObserver'in window){this._intersection=new IntersectionObserver(es=>{this._visible=es.some(e=>e.isIntersecting);this.updateMotion();},{threshold:0});this._intersection.observe(this);}else this._visible=true;
      this._frame=requestAnimationFrame(()=>this.watchImages());this.updateMotion();
    }
    watchImages(){
      const images=[...this.querySelectorAll('.cfbh-mascot img')];if(!images.length)return;
      const check=()=>{this._imagesReady=images.every(i=>i.complete&&i.naturalWidth>0);this.updateMotion();};
      for(const i of images){i.addEventListener('load',check,{signal:this._abort.signal});i.addEventListener('error',check,{signal:this._abort.signal});}check();
    }
    updateMotion(){
      const active=this._connected&&this._visible&&this._imagesReady&&document.visibilityState!=='hidden';
      this.toggleAttribute('data-motion-paused',!active);
      if(active&&!this._running){this._running=true;this._winkTimer=setTimeout(()=>this.wink(),800);}else if(!active)this.stopWink();
    }
    wink(){
      if(!this._running)return;this.setAttribute('data-winking','');
      this._openTimer=setTimeout(()=>{this.removeAttribute('data-winking');if(this._running)this._winkTimer=setTimeout(()=>this.wink(),2600);},900);
    }
    stopWink(){clearTimeout(this._winkTimer);clearTimeout(this._openTimer);this._running=false;this.removeAttribute('data-winking');}
    disconnectedCallback(){this._connected=false;this.stopWink();cancelAnimationFrame(this._frame);this._abort?.abort();this._size?.disconnect();this._intersection?.disconnect();this._reduced?.removeEventListener('change',this._onReduced);}
  }
  customElements.define(tag,CharmifyBuenFinV2);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-precio-sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cf-buen-fin-header')) return;
  const instances = new Set();
  const overlaySelector = 'dialog[open],cart-drawer.active,cart-drawer[open],#CartDrawer.active,#CartDrawer.open,#CartDrawer.is-open,cart-drawer.is-open,.drawer.active,.drawer.is-open,[role="dialog"][aria-modal="true"]:not([aria-hidden="true"]),.modal--is-active,.search-modal[open]';
  const isVisible = node => {
    if (!node.isConnected || node.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    for (let parent = node; parent; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS' && !parent.open) return false;
      const style = getComputedStyle(parent);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    const rect = node.getBoundingClientRect();
    return rect.width > 8 && rect.height > 8 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  };
  function chooseOwner() {
    let claimed = false;
    instances.forEach(instance => {
      const eligible = instance.isConnected && instance.dataset.active === 'true' && instance.dataset.closed !== 'true' && instance.dataset.mounted === 'fixed';
      const duplicate = eligible && claimed;
      if (instance.dataset.duplicate !== String(duplicate)) instance.dataset.duplicate = String(duplicate);
      if (eligible && !duplicate) claimed = true;
      instance.reserve();
    });
  }
  function parseEnd(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const [,y,m,d,h,min,s] = match;
    const year=Number(y), month=Number(m), day=Number(d);
    if (month<1 || month>12 || day<1 || day>new Date(Date.UTC(year,month,0)).getUTCDate() || Number(h)>23 || Number(min)>59 || Number(s || 0)>59) return NaN;
    return Date.parse(value);
  }
  class CharmifyBuenFinHeader extends HTMLElement {
    connectedCallback() {
      if (this.moving || this.initialized) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.init(); }, {once:true});
      } else queueMicrotask(() => { if (this.isConnected) this.init(); });
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.editor = this.dataset.editor === 'true';
      this.campaign = this.dataset.mode === 'campaign';
      this.daily = this.dataset.mode === 'daily';
      if(this.daily){
        try{this.dayFormatter=new Intl.DateTimeFormat('en-CA',{timeZone:this.dataset.timezone||'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit'});}
        catch(_){this.daily=false;this.dataset.mode='permanent';}
      }
      this.end = this.campaign ? parseEnd(this.dataset.end) : null;
      this.closeButton = this.querySelector('[data-close]');
      this.panel = this.querySelector('.cbs-panel');
      this.owner = this.closest('.shopify-section');
      this.storageKey = `cf-buen-fin-header:${this.dataset.campaign || 'offer'}:${this.dataset.mode}:${this.dataset.end || ''}`;
      instances.add(this);
      if (this.campaign && !Number.isFinite(this.end)) {
        this.dataset.invalid = 'true';
        if (this.editor) this.showEditorNote('Selecciona una fecha de cierre real con zona horaria. Esta campaña no se muestra a clientes hasta configurarla.');
        else { this.dataset.active = 'false'; return; }
      }
      if (!this.editor && this.dataset.dismiss === 'session') {
        try { if (sessionStorage.getItem(this.storageKey) === 'closed') this.dataset.closed = 'true'; } catch (_) { /* Storage may be unavailable. */ }
      }
      this.dataset.active = 'true';
      this.closeButton.hidden = false;
      this.closeButton.addEventListener('click', () => this.close(), {signal:this.abort.signal});
      if (this.daily || (this.campaign && Number.isFinite(this.end))) {
        this.querySelector('[data-countdown]').hidden = false;
        this.querySelector('[data-permanent-feature]').hidden = true;
        this.tick();
      }
      this.mount();
      if('ResizeObserver' in window){
        this.resize = new ResizeObserver(() => this.reserve());
        this.resize.observe(this.panel);
      }
      document.addEventListener('visibilitychange', () => {
        clearTimeout(this.timer);
        if (!document.hidden && (this.daily || (this.campaign && Number.isFinite(this.end)))) this.tick();
      }, {signal:this.abort.signal});
      document.addEventListener('shopify:section:select', event => {
        if (this.editor && event.detail?.sectionId === this.dataset.sectionId) {
          this.dataset.closed = 'false'; if(this.daily || (this.campaign && Number.isFinite(this.end)))this.tick(); chooseOwner();
        }
      }, {signal:this.abort.signal});
      document.addEventListener('shopify:section:unload', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.remove();
      }, {signal:this.abort.signal});
      window.addEventListener('resize', () => { this.checkOverlay(); this.reserve(); }, {signal:this.abort.signal});
      window.visualViewport?.addEventListener('resize', () => this.checkOverlay(), {signal:this.abort.signal});
      document.addEventListener('focusin', () => this.checkOverlay(), {signal:this.abort.signal});
      document.addEventListener('focusout', () => setTimeout(() => {if(this.isConnected)this.checkOverlay();},0), {signal:this.abort.signal});
      this.observer = new MutationObserver(records => {
        if (this.anchor && !this.anchor.isConnected) {this.remove(); return;}
        if (records.every(record => this.contains(record.target))) return;
        cancelAnimationFrame(this.overlayFrame);
        this.overlayFrame = requestAnimationFrame(() => this.checkOverlay());
      });
      this.observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','open','aria-hidden','aria-modal','hidden','inert','style']});
      this.checkOverlay();
      chooseOwner();
      if (this.dataset.closed !== 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.dataset.enter = 'true';
        this.entryTimer = setTimeout(() => {this.dataset.enter='false';},550);
      }
    }
    mount() {
      this.dataset.mount='inline';
      this.dataset.mounted='inline';
    }
    reserve() {
      if (!this.spacer) return;
      const active=this.dataset.active==='true' && this.dataset.closed!=='true' && this.dataset.expired!=='true' && this.dataset.duplicate!=='true';
      const bottom=Number.parseFloat(getComputedStyle(this).bottom)||0;
      const height=active ? Math.ceil(this.panel.getBoundingClientRect().height+bottom+16) : 0;
      if(this.spacer.style.height!==`${height}px`)this.spacer.style.height=`${height}px`;
    }
    nextMidnight(now) {
      const day=this.dayFormatter.format(now);
      let low=Math.floor(now/1000),high=low+36*3600;
      while(high-low>1){
        const mid=Math.floor((low+high)/2);
        if(this.dayFormatter.format(mid*1000)===day)low=mid;
        else high=mid;
      }
      this.dailyDay=day;
      return high*1000;
    }
    tick() {
      clearTimeout(this.timer);
      if (this.dataset.closed==='true') return;
      const now=Date.now();
      if(this.daily && (!this.end || now>=this.end || this.dayFormatter.format(now)!==this.dailyDay))this.end=this.nextMidnight(now);
      const seconds=Math.max(0,Math.ceil((this.end-now)/1000));
      if (seconds===0) {
        this.dataset.expired='true';
        this.dataset.active=this.editor?'true':'false';
        if(this.editor)this.showEditorNote('La fecha de esta campaña ya venció. No se muestra a clientes y el reloj no se reinicia.');
        chooseOwner();
        return;
      }
      this.dataset.expired='false';
      let hours=Math.floor(seconds/3600), minutes=Math.floor(seconds%3600/60), secs=seconds%60;
      const labels=['horas','min','seg'];
      if(hours>=100){hours=Math.floor(seconds/86400);minutes=Math.floor(seconds%86400/3600);secs=Math.floor(seconds%3600/60);labels.splice(0,3,'días','horas','min');}
      const values=[hours,minutes,secs],fields=['hours','minutes','seconds'];
      fields.forEach((field,index)=>{
        const node=this.querySelector(`[data-${field}]`),value=String(values[index]).padStart(2,'0');
        if(node.textContent!==value)node.textContent=value;
        node.nextElementSibling.textContent=labels[index];
      });
      this.querySelector('[data-clock]').setAttribute('aria-label',`${this.daily?'Cuenta regresiva diaria':'Tiempo restante de la campaña'}: ${values[0]} ${labels[0]}, ${values[1]} ${labels[1]} y ${values[2]} ${labels[2]}.`);
      if(!document.hidden)this.timer=setTimeout(()=>this.tick(),Math.max(100,1000-(Date.now()%1000)));
    }
    showEditorNote(text) {const note=this.querySelector('[data-editor-note]');note.textContent=text;note.hidden=false;}
    close() {
      const hadFocus=this.contains(document.activeElement);
      this.dataset.closed='true';
      clearTimeout(this.timer);
      if(!this.editor) instances.forEach(instance => {
        if(instance.storageKey===this.storageKey){instance.dataset.closed='true';clearTimeout(instance.timer);}
      });
      if(!this.editor && this.dataset.dismiss==='session'){
        try{sessionStorage.setItem(this.storageKey,'closed');}catch(_){/* Dismissal still works on this page. */}
      }
      chooseOwner();
      if(hadFocus){
        const target=document.querySelector('main a[href],#MainContent a[href],main button:not([disabled]),#MainContent button:not([disabled])');
        if(target)target.focus({preventScroll:true});
        else{document.activeElement?.blur();}
      }
    }
    checkOverlay() { this.dataset.overlay='false'; }
    disconnectedCallback() {
      if(this.moving)return;
      this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();
      clearTimeout(this.timer);clearTimeout(this.entryTimer);cancelAnimationFrame(this.overlayFrame);
      this.spacer?.remove();this.anchor?.remove();
      instances.delete(this);this.initialized=false;chooseOwner();
    }
  }
  customElements.define('cf-buen-fin-header',CharmifyBuenFinHeader);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1920px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('load', () => {
        this.setHeaderHeight.bind(this)
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${document.querySelector('.section-header').offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      tooltip.classList.add('show');
      update();
    }

    function hideTooltip() {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => {
        tooltip.classList.remove('hiding');
      }, 200);
    }

    const events = [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ];

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      events.forEach(([event, listener]) => {
        btn.addEventListener(event, listener);
      });
    }
  }
}

customElements.define('lumin-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();
})();
